export default __webpack_public_path__ + "static/media/frank-marcaccio.c2f188cc.png";